import { boolean, coerce, string } from 'superstruct';

/**
 * Allows the strings `true` or `false` to be accepted for a boolean.
 * Requires coercion to be set.
 */
export const parsableBoolean = () => coerce(boolean(), string(), value => value === 'true' ? true : value === 'false' ? false : null);